/* @ngInject */
function sliderService () {
  var sliders = []
  return {
    register,
    registerState,
    setState,
    unregister
  }

  function register (id) {
    sliders[id] = {}
  }

  function registerState (id, state, callback) {
    sliders[id][state] = callback
  }

  function setState (id, state, data) {
    sliders[id][state](data)
  }

  function unregister (id) {
    sliders[id] = undefined
  }
}

export { sliderService }
